import angular from "angular";
import { IGridSettings } from "../../grids/settings/gridSettingsService";
import { ColDef } from "../../grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../grids/columns/columnDefinitionService";
import { IRowCommandEventArgs } from "../../grids/controller";
import { SelectRecordModalConfig } from "./service";

export class SelectRecordModalComponentController {
  static $inject = [ColumnDefinitionServiceName];

  title: string = "";
  columns: ColDef[] = [];
  gridSettings!: IGridSettings;
  showDoneButton: boolean = false;
  selectedRows: any[] = [];
  /*bindings*/
  resolve!: { config: SelectRecordModalConfig };
  modalInstance!: angular.ui.bootstrap.IModalInstanceService;
  /*end bindings*/


  constructor(
    private readonly columnDefinitionService: ColumnDefinitionService
  ) {
    this.setModalWidth("950px");
  }

  $onInit(): void {
    const config = this.resolve?.config ?? {};
    const gridConfiguration = config.gridConfiguration;
    this.showDoneButton = !!config.showDoneButton;
    this.title = config.title;

    this.columns = [
      this.columnDefinitionService.getCommandColDef({
        headerName: "select",
        iconClass: "fa fa-plus-circle text-primary",
        name: "select",
      }),

      ...(gridConfiguration.columns ?? []),
    ];

    if (this.showDoneButton) {
      const selectColumn: ColDef = {
        headerName: "Select",
        field: "selected",
        colId: "select",
        width: 70,
        suppressSorting: true,
        suppressMenu: true,
        cellRenderer: (params: any) => {
          const id = params.data?.Id ?? params.data?.id;
          const checked = this.selectedRows.includes(id) ? "checked" : "";
          return `<input type="checkbox" ${checked} />`;
        },
        cellClicked: (params: any) => {
          const id = params.data?.Id ?? params.data?.id;
          const idx = this.selectedRows.indexOf(id);

          if (idx === -1) this.selectedRows.push(id);
          else this.selectedRows.splice(idx, 1);

          params.api?.refreshCells?.({ rowNodes: [params.node], force: true });
        },
      };

      // Add checkbox as first column
      this.columns.unshift(selectColumn);
    }

    this.gridSettings = gridConfiguration.gridSettings!;
  }

  onItemCommand(args: IRowCommandEventArgs<any>) {
    if (args.commandName === "select") {
      this.resolve?.config?.onItemSelected(args.data, this.modalInstance);
    }
  }

  toggleRowSelection() {
    this.modalInstance.dismiss("cancel");
  }

  cancel() {
    this.modalInstance.dismiss("cancel");
  }

  submitSelection() {
    if (!this.selectedRows.length) {
      alert("Please select at least one record.");
      return;
    }
  
    if (this.resolve?.config?.onSubmitSelection) {
      this.resolve.config.onSubmitSelection(this.selectedRows, this.modalInstance);
      return;
    }
  
    console.warn("No onSubmitSelection callback passed.");
    this.modalInstance.close(this.selectedRows);
  }
  

  private setModalWidth(width: string) {
    const elements = document.querySelector(".modal-content");
    if (!elements) return;
    var modalWindow = angular.element(elements);
    modalWindow.css("width", width);
  }
}
